import { z } from "zod";
const CustomerMembershipSchema = z.enum([
  "STAR",
  "VVIP",
  "VIP",
  "DIAMOND",
  "GOLD",
  "SILVER",
  "FAMILY"
]);
export {
  CustomerMembershipSchema
};
//# sourceMappingURL=myinfo.js.map